import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypesPriorityActionAsync } from '../redux/actions/typePriorityActions'

export const useTypesPriority = () => {
  const { typesPriorityState } = useSelector(
    (state: RootState) => state.typePriority
  )
  const dispatch = useDispatch()

  const getTypesPriority = () => {
    dispatch(getTypesPriorityActionAsync())
  }

  return { typesPriorityState, getTypesPriority }
}
